export default __webpack_public_path__ + "static/media/front2.8ec3be92.png";